import { RiskManagementSettingType } from 'src/@type/risk-management/types';

function path(root: string, sublink: string) {
    return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const DASH_ROOT =  '/t360'; 

export const PATH_AUTH = {
    root: ROOTS_AUTH,
    login: path(ROOTS_AUTH, '/login'),
    loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
    verify: path(ROOTS_AUTH, '/verify'),
    resetPassword: path(ROOTS_AUTH, '/reset-password'),
    newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const path_dashboard = {
        root: DASH_ROOT,
        general: {
            app: path(DASH_ROOT, '/app'),
        },
        permissionDenied: path(DASH_ROOT, '/permission-denied'),
        api: {
            root: path(DASH_ROOT, '/api'),
            api_trace: path(DASH_ROOT, '/api/api-trace'),
            fusion_summary: path(DASH_ROOT, '/api/fusion-summary'),
        },
        broker_hub: {
            root: path(DASH_ROOT, '/broker-hub'),
            process_monitor: path(DASH_ROOT, '/broker-hub/process-monitor'),
            process_status: path(DASH_ROOT, '/broker-hub/process-status')
        },
        physical_markets: {
            root: path(DASH_ROOT, '/physical-markets'),
            daily_pricing: path(DASH_ROOT, '/physical-markets/daily-pricing')
        },
        risk_reports: {
            root: path(DASH_ROOT, '/risk-reports'),
            global_position: path(DASH_ROOT, '/risk-reports/global-position'),
            desk_position: path(DASH_ROOT, '/risk-reports/desk-position'),
            focus_report: path(DASH_ROOT, '/risk-reports/focus-report'),
            position_by_desk: path(DASH_ROOT, '/risk-reports/position-by-desk'),
            position_by_product: path(DASH_ROOT, '/risk-reports/position-by-product'),
            greeks_report: path(DASH_ROOT, '/risk-reports/greeks-report'),
        },
        risk_management: {
            root: path(DASH_ROOT, '/risk-management'),
            settings: {
                root: path(DASH_ROOT, '/risk-management/settings/'),
                desks: path(DASH_ROOT, '/risk-management/settings/desks'),
                portfolios: path(DASH_ROOT, '/risk-management/settings/portfolios'),
                limitAlerts: path(DASH_ROOT, '/risk-management/settings/limit-alerts'),
                reports: path(DASH_ROOT, '/risk-management/settings/reports')
            } as RiskManagementSettingType
        },
        management: {
            root: path(DASH_ROOT, '/management'),
            users: path(DASH_ROOT, '/management/users'),
        }
    };